export default __webpack_public_path__ + "static/media/dai.849478a7.png";